<template>
  <div>
    <RightTitle title="空间设置"></RightTitle>

    <!-- 表单 -->
    <div class="uar_form">
      <el-form ref="form" :model="form" label-width="100px" size="medium">
        <el-form-item label="空间名称">
          <el-input v-model="form.spaceName" clearable placeholder="请输入空间名称" style="width:400px;"></el-input>
        </el-form-item>
        <el-form-item label="空间公告">
          <el-input
            type="textarea"
            v-model="form.notice"
            clearable
            placeholder="请输入空间公告"
            :rows="5"
            maxlength="50"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item label="空间模板">
          <div class="clear">
            <div
              class="avatar_list"
              v-for="(item, index) in templateArr"
              :key="index"
              @click="selectTemplate(item.key)"
            >
              <el-tooltip :content="item.name">
                <el-badge :value="templateValue(item.key)" class="item">
                  <el-avatar shape="square" :size="100" fit="cover" :src="item.image"></el-avatar>
                </el-badge>
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">立即提交</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 记载组件
import RightTitle from "../../../components/RightTitle";
// 加载api
import { getUserInfo, setSpace } from "../../../api/user";
import { getBaseConfig } from "../../../api/index";
export default {
  name: "person_space",
  components: {
    RightTitle
  },
  beforeRouteEnter(to, from, next) {
    getUserInfo().then(res => {
      next(vm => {
        vm.form.spaceName = res.data.spaceName;
        vm.form.notice = res.data.spaceNotice;
        vm.form.spaceTemplate = res.data.spaceTemplate;
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    getUserInfo().then(res => {
      this.form.spaceName = res.data.spaceName;
      this.form.notice = res.data.spaceNotice;
      this.form.spaceTemplate = res.data.spaceTemplate;
      next();
    });
  },
  mounted() {
    // 获取空间信息
    getBaseConfig({ type: "space_template" }).then(res => {
      this.templateArr = res.data;
    });
  },
  data() {
    return {
      form: {
        spaceName: "",
        notice: "",
        spaceTemplate: ""
      },
      templateArr: [],
      loading: false
    };
  },
  methods: {
    //   选择模板
    selectTemplate(item) {
      this.form.spaceTemplate = item;
    },
    templateValue(value) {
      return this.form.spaceTemplate == value ? "√" : "";
    },
    //   提交
    submitForm() {
      // console.log(this.form);
      this.loading = true;
      setSpace(this.form).then(res => {
        if (res.status == 200) {
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success"
          });
          this.loading = false;
        } else {
          this.$notify({
            title: "警告",
            message: res.message,
            type: "warning"
          });
          this.loading = false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style scoped>
.avatar_list {
  float: left;
  margin-right: 15px;
}
</style>